export default {
  'Teklif Formu': 'Formularz Oferty',
  'Kayıtlı Teklifler': 'Zapisane Oferty',
  'Kullanıcı Adı': 'Nazwa Użytkownika',
  'Şifre': 'Hasło',
  'Giriş Yap': 'Zaloguj się',
  'Çıkış Yap': 'Wyloguj się',
  'KDV Oranı': 'Stawka VAT',
  'Teklif Durumu': 'Status Oferty',
  'Kaydet': 'Zapisz',
  'PDF Önizleme': 'Podgląd PDF',
  'PDF\'ye Aktar': 'Eksport do PDF',
  'E-posta ile Gönder': 'Wyślij przez Email',
  'Alıcı': 'Odbiorca',
  'Tarih': 'Data',
  'Genel Toplam': 'Suma Całkowita',
  'Not': 'Notatka',
  'KDV': 'VAT',
  'Alt Toplam': 'Suma Częściowa',
  'Açıklama': 'Opis',
  'Ürün Adı': 'Nazwa Produktu',
  'SUT Kodu': 'Kod SUT',
  'Birim Alış Fiyatı': 'Cena Jednostkowa',
  'Sipariş Adedi': 'Ilość Zamówienia',
  'Promosyon Ürün': 'Produkt Promocyjny',
  'Toplam Adet': 'Łączna Ilość',
  'Sipariş Tutarı': 'Kwota Zamówienia',
  'Durum': 'Status',
  'Kabul Edildi': 'Zaakceptowane',
  'Reddedildi': 'Odrzucone',
  'Gönderildi': 'Wysłane',
  'Taslak': 'Szkic',
  'Yurtiçi': 'Krajowe',
  'Yurtdışı': 'Międzynarodowe',
  'Sipariş Oluştur': 'Utwórz Zamówienie',
  'Ürün Sıralaması': 'Sortowanie Produktów',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Produkty są posortowane według popularności i poziomu ważności',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Produkty kardiologii i chirurgii naczyniowej są wyświetlane jako priorytetowe',
  'Ürün adı, açıklama veya barkod ile ara...': 'Szukaj według nazwy produktu, opisu lub kodu kreskowego...',
  'Tüm Kategoriler': 'Wszystkie Kategorie',
  'Kutu görünüm': 'Widok siatki',
  'Liste görünüm': 'Widok listy',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Nie znaleziono produktów spełniających Twoje kryteria',
  'Ürün Adı Yok': 'Brak Nazwy Produktu',
  'Kategori Yok': 'Brak Kategorii',
  'Açıklama yok': 'Brak opisu',
  'Firma Bilgilerini Doldurun': 'Wypełnij Informacje o Firmie',
  'Sepete Ekle': 'Dodaj do Koszyka',
  'Firma Bilgileri': 'Informacje o Firmie',
  'Ülke Seçimi': 'Wybór Kraju',
  'Türkiye': 'Turcja',
  'Almanya': 'Niemcy',
  'ABD': 'USA',
  'Firma Ünvanı': 'Nazwa Firmy',
  'Vergi Dairesi': 'Urząd Skarbowy',
  'Vergi Numarası': 'NIP',
  'Adres': 'Adres',
  'Şehir': 'Miasto',
  'Yetkili': 'Osoba Uprawniona',
  'Telefon': 'Telefon',
  'Email': 'Email',
  'Bilgileri İlet': 'Przekaż Informacje',
  'Lütfen eksik alanları doldurun': 'Proszę wypełnić puste pola',
  'Firma kaydedilemedi': 'Nie udało się zapisać firmy',
  'Firma bilgileri başarıyla iletildi': 'Informacje o firmie zostały pomyślnie przekazane',
  'Firma Ünvanı:': 'Nazwa Firmy:',
  'Yetkili Kişi:': 'Osoba Uprawniona:',
  'Sepetiniz': 'Twój Koszyk',
  'Sepetiniz boş': 'Twój koszyk jest pusty',
  'adet': 'szt',
  'Düzenle': 'Edytuj',
  'Kaldır': 'Usuń',
  'Siparişi Tamamla': 'Zakończ Zamówienie',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Proszę najpierw przekazać pełne informacje o firmie',
  'Sipariş başarıyla kaydedildi': 'Zamówienie zostało pomyślnie zapisane',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Wiadomość powitalna i link dostępu zostały wysłane na Twój email',
  'Link 3 gün geçerlidir': 'Link jest ważny przez 3 dni',
  'Sipariş kaydedilemedi': 'Nie udało się zapisać zamówienia',
  'Firma Bilgileri Gerekli': 'Wymagane Informacje o Firmie',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Najpierw wypełnij informacje o firmie, aby dodać do koszyka',
  'Önce Bilgileri Doldurun': 'Najpierw Wypełnij Informacje',
  'Uyarı': 'Ostrzeżenie',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Musisz najpierw wypełnić informacje o firmie, aby dodać do koszyka',
  'SUT Kütüphanesi Tanımı': 'Definicja Biblioteki SUT',
  'SUT Kodu:': 'Kod SUT:',
  'Standart': 'Standardowy',
  'Açıklama (isteğe bağlı)': 'Opis (opcjonalny)',
  'Partner Ol': 'Zostań Partnerem',
  'Partner başvuru popup açılacak': 'Otworzy się popup aplikacji partnera',
  'Dil': 'Język',
  'E-posta': 'Email',
  'globalPartnersTitle': 'Współpraca z 30.000 Partnerów na Całym Świecie',
  'globalPartnersDesc': 'Nasza rozległa globalna sieć 30.000 partnerów wspiera wspólną innowację, dzielenie się wiedzą i wzajemny sukces. Razem nieustannie poszerzamy granice opieki nad pacjentami.',
  'bayiBasvuru': 'Formularz Aplikacji Partnera INVAMED',
  'bayiBasvuruDesc': 'Wypełnij poniższy formularz, aby dołączyć do sieci partnerów INVAMED. Po przeanalizowaniu Twojej aplikacji skontaktujemy się z Tobą.',
  'applyFields': {
    'firma': 'Nazwa Firmy',
    'vergiNo': 'Urząd Skarbowy / NIP',
    'yetkili': 'Pełne Imię i Nazwisko Osoby Uprawnionej',
    'telefon': 'Telefon',
    'email': 'Email',
    'adres': 'Adres',
    'sektor': 'Obszar Działalności / Sektor',
    'sicil': 'Numer Rejestrowy',
    'web': 'Strona Internetowa'
  },
  'Şifremi Unuttum': 'Zapomniałem Hasła',
  'Demo Giriş': 'Logowanie Demo',
  'Bayi Başvurusu': 'Aplikacja Partnera',
  'Yardım': 'Pomoc',
  'Giriş yapılıyor...': 'Logowanie...',
  'E-posta veya şifre hatalı': 'Nieprawidłowy email lub hasło',
  'Şifre sıfırlama e-postası gönderildi': 'Email do resetowania hasła został wysłany',
  'E-posta gönderilemedi': 'Nie udało się wysłać emaila',
  'Vergi Dairesi / Vergi No': 'Urząd Skarbowy / NIP',
  'Yetkili Adı Soyadı': 'Pełne Imię i Nazwisko Osoby Uprawnionej',
  'Faaliyet Alanı / Sektör': 'Obszar Działalności / Sektor',
  'Ticaret Sicil No': 'Numer Rejestrowy',
  'Web Sitesi': 'Strona Internetowa',
  'Temel Bilgiler': 'Podstawowe Informacje',
  'Ek Bilgiler': 'Dodatkowe Informacje',
  'Başvuru Gönder': 'Wyślij Aplikację',
  'Başvuru gönderiliyor...': 'Wysyłanie aplikacji...',
  'Başvuru başarıyla gönderildi': 'Aplikacja została pomyślnie wysłana',
  'Başvuru gönderilemedi': 'Nie udało się wysłać aplikacji',
  'Sözleşme şartlarını kabul ediyorum': 'Akceptuję warunki umowy',
  'Dosya Yükle': 'Prześlij Plik',
  'Dosya seçilmedi': 'Nie wybrano pliku',
  'Dosya yüklendi': 'Plik został pomyślnie przesłany',
  'Dosya yüklenemedi': 'Nie udało się przesłać pliku',
  'Tamamla': 'Zakończ',
  'Geri': 'Wstecz',
  'İleri': 'Dalej',
  'Kapat': 'Zamknij',
  'Yardım İçeriği': 'Zawartość Pomocy',
  'dil': 'Język',
  'Üye Ol': 'Zarejestruj się',
  'Üye Değil Misiniz?': 'Nie Jesteś Zarejestrowany?',
  'Şimdi Üye Ol': 'Zarejestruj się Teraz',
  'Misafir Kullanıcı': 'Użytkownik Gość',
  'Hızlı Sipariş': 'Szybkie Zamówienie',
  'Misafir Olarak Sipariş Verin': 'Złóż Zamówienie jako Gość',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Szybko wybierz swoje produkty i utwórz zamówienie bez logowania',
  'Giriş yapmadan sipariş oluşturun': 'Utwórz zamówienie bez logowania',
  'Anında Erişim': 'Natychmiastowy Dostęp',
  'Tüm ürünlere anında erişim': 'Natychmiastowy dostęp do wszystkich produktów',
  'Güvenli İşlem': 'Bezpieczna Transakcja',
  'SSL korumalı güvenli sipariş': 'Bezpieczne zamówienie z ochroną SSL',
  'Misafir Olarak Sipariş Oluştur': 'Utwórz Zamówienie jako Gość',
  'İpucu:': 'Wskazówka:',
  'Daha fazla özellik için üye olun': 'Zarejestruj się, aby uzyskać więcej funkcji',
  'Ücretsiz': 'Bezpłatnie',
  'Hızlı': 'Szybko',
  'Güvenli': 'Bezpiecznie',
  'bayilikSozlesme': 'Przeczytałem i akceptuję warunki oraz umowę partnerstwa.',
  'geri': 'Wstecz',
  'basvuruGonder': 'Wyślij Aplikację',
  'ileri': 'Dalej',
  'sozlesmeGonderildi': 'Umowa Wysłana na Twój Email!',
  'sozlesmeDesc': 'Proszę przesłać Umowę Partnerstwa INVAMED i wymagane dokumenty wysłane na Twój email.',
  'tamamla': 'Zakończ Aplikację',
  'basvuruAlindi': 'Twoja Aplikacja Została Przyjęta!',
  'basvuruAlindiDesc': 'Zespół INVAMED przeanalizuje Twoją aplikację i skontaktuje się z Tobą najszybciej jak to możliwe.',
  'Başvuru Durumu': 'Status aplikacji',
  'Başvurunuz onay sürecindedir': 'Twoja aplikacja jest w trakcie przeglądu',
  'sifreSifirla': 'Resetowanie Hasła',
  'sifreSifirlaDesc': 'Wprowadź swój zarejestrowany email, wyślemy instrukcje resetowania hasła.',
  'gonder': 'Wyślij',
  'talimatGonderildi': 'Instrukcje Wysłane',
  'sentDesc': 'Instrukcje resetowania hasła zostały wysłane na <b>{email}</b>. Proszę sprawdzić swój email.',
  'helpTitle': 'Jak Mogę Się Zalogować?',
  'helpList': [
    'Aby zalogować się do panelu partnera INVAMED, wprowadź swój zarejestrowany email i hasło.',
    'Aby zalogować się z użytkownikiem demo:',
    'Jeśli zapomniałeś hasła, możesz poprosić o reset przez link "Zapomniałem Hasła".',
    'Jeśli masz problemy z logowaniem, upewnij się, że wprowadzasz poprawny email i hasło. Jeśli problem nadal występuje, skontaktuj się z naszym zespołem wsparcia.'
  ],
  'partnerlikSozlesmeTitle': 'Umowa i Warunki Partnerstwa INVAMED',
  'partnerlikSozlesmeText': `1. POSTANOWIENIA OGÓLNE

Niniejsza umowa została zawarta między INVAMED (dalej "Spółka") a kandydatem na partnera (dalej "Partner") w celu współpracy w sprzedaży sprzętu i wyposażenia medycznego.

2. WARUNKI PARTNERSTWA

2.1. Partner musi posiadać uprawnienia prawne do sprzedaży sprzętu medycznego.
2.2. Partner musi być organizacją działającą w sektorze opieki zdrowotnej.
2.3. Partner musi posiadać wymagane licencje i certyfikaty.
2.4. Partner musi być wiarygodny finansowo.

3. ZOBOWIĄZANIA STRON

Zobowiązania Spółki:
3.1. Dostarczanie wysokiej jakości produktów i usług
3.2. Zapewnianie wsparcia technicznego
3.3. Prowadzenie szkoleń i informacji
3.4. Przejrzystość w ustalaniu cen

Zobowiązania Partnera:
3.1. Przechowywanie produktów w odpowiednich warunkach
3.2. Zapewnianie wysokiej jakości obsługi klienta
3.3. Przestrzeganie przepisów prawnych
3.4. Ochrona marki Spółki

4. USTALANIE CEN I PŁATNOŚCI

4.1. Ceny ustalane są przez Spółkę
4.2. Partner jest zobowiązany do przestrzegania ustalonych cen
4.3. Warunki płatności określane są osobno
4.4. Stawki komisowe mogą się różnić w zależności od wyników

5. POUFNOŚĆ I BEZPIECZEŃSTWO

5.1. Strony są zobowiązane do ochrony poufnych informacji siebie nawzajem
5.2. Informacje o klientach muszą być poufne
5.3. Należy przestrzegać standardów bezpieczeństwa danych

6. OKRES OBOWIĄZYWANIA I ROZWIĄZANIE UMOWY

6.1. Niniejsza umowa obowiązuje przez 1 rok
6.2. Może być przedłużona za obopólną zgodą
6.3. Może być rozwiązana z 30-dniowym wypowiedzeniem
6.4. Może być rozwiązana natychmiast w przypadku poważnego naruszenia

7. ROZWIĄZYWANIE SPORÓW

7.1. Spory próbuje się rozwiązać najpierw przez negocjacje
7.2. W przypadkach, które nie mogą być rozwiązane, właściwe są sądy Republiki Turcji

8. OBOWIĄZYWANIE

Niniejsza umowa została przeczytana, zrozumiana i zaakceptowana przez strony. Oświadczam, że akceptuję wszystkie postanowienia niniejszej umowy i będę wypełniać swoje zobowiązania.`,
  'partnerlikSozlesmeOnay': 'Przeczytałem, zrozumiałem i zaakceptowałem Umowę i Warunki Partnerstwa INVAMED powyżej. Oświadczam, że akceptuję wszystkie postanowienia niniejszej umowy i będę wypełniać swoje zobowiązania.',
  'sozlesmeyiGoruntule': 'Wyświetl Umowę',
  'sozlesmeyiKapat': 'Zamknij',
  'Ürün': 'Produkt',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Wybierz z listy produktów, aby dodać produkt',
  'Etiketler': 'Etykiety',
  'Öncelikli': 'Priorytetowy',
  'Ülke Seçiniz': 'Wybierz Kraj',
  'Firma / Sağlık Profesyoneli': 'Firma / Profesjonalista Opieki Zdrowotnej',
  'Şehir Seçiniz': 'Wybierz Miasto',
  'Yetkili Kişi': 'Osoba Uprawniona',
  'UDI Kodu': 'Kod UDI',
  'Teklif başarıyla kaydedildi!': 'Oferta została pomyślnie zapisana!',
  'Aynı teklif zaten kayıtlı!': 'Taka sama oferta jest już zapisana!',
  'Kullanıcı adı veya şifre hatalı!': 'Nieprawidłowa nazwa użytkownika lub hasło!',
  'Teklif No': 'Numer Oferty',
  'Teklifler': 'Oferty',
  'Yedeklenecek teklif yok!': 'Brak ofert do utworzenia kopii zapasowej!',
  'Yedek dosyası indirildi.': 'Plik kopii zapasowej został pobrany.',
  'Yedek başarıyla yüklendi.': 'Kopia zapasowa została pomyślnie załadowana.',
  'Geçersiz veya bozuk dosya!': 'Nieprawidłowy lub uszkodzony plik!',
  'Yedekle (JSON)': 'Kopia zapasowa (JSON)',
  'Geri Yükle': 'Przywróć',
  'Kayıtlı teklif yok.': 'Brak zapisanych ofert.',
  'E-posta Durumu': 'Status Email',
  'İşlemler': 'Operacje',
  'E-posta ile gönderildi': 'Wysłane przez email',
  'E-posta gönderilmedi': 'Email nie został wysłany',
  'Görüntüle': 'Wyświetl',
  'Sil': 'Usuń',
  'Gönderildi': 'Wysłane',
  'Gönderilmedi': 'Nie wysłane',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'Nie znaleziono ID Oferty! Proszę spróbować ponownie.',
  'Lütfen partner seçiniz.': 'Proszę wybrać partnera.',
  'Lütfen teslimat tarihi belirtiniz.': 'Proszę określić datę dostawy.',
  'Proforma başarıyla oluşturuldu!': 'Proforma została pomyślnie utworzona!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'Proforma została utworzona, ale nie udało się dodać produktu. Sprawdź konsolę, aby uzyskać szczegóły.',
  'Link başarıyla silindi': 'Link został pomyślnie usunięty',
  'Link kopyalandı!': 'Link został skopiowany!',
  'Ödeme durumu başarıyla güncellendi!': 'Status płatności został pomyślnie zaktualizowany!',
  'dosyası okunamadı!': 'nie udało się odczytać pliku!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'Musisz wybrać kolumny kodu SUT i ceny dla wszystkich plików!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'Nie znaleziono prawidłowych wierszy do załadowania! Upewnij się, że w pliku(ach) są wiersze z wypełnionym kodem SUT i ceną.',
  'Yükleme sırasında hata oluştu!': 'Wystąpił błąd podczas ładowania!',
  'Otomatik etiket ekleme başarısız!': 'Automatyczne dodawanie etykiet nie powiodło się!',
  'Etiketler başarıyla güncellendi!': 'Etykiety zostały pomyślnie zaktualizowane!',
  'Etiketler güncellenirken hata oluştu!': 'Wystąpił błąd podczas aktualizacji etykiet!',
  'Resim başarıyla yüklendi!': 'Obraz został pomyślnie przesłany!',
  'Resim yüklendi ama ürün güncellenemedi!': 'Obraz został przesłany, ale nie udało się zaktualizować produktu!',
  'Resim yüklenirken hata oluştu!': 'Wystąpił błąd podczas przesyłania obrazu!',
  'Ürün başarıyla güncellendi!': 'Produkt został pomyślnie zaktualizowany!',
  'Ürün güncellenirken hata oluştu!': 'Wystąpił błąd podczas aktualizacji produktu!',
  'Hata:': 'Błąd:',
  'Güncelleme hatası:': 'Błąd aktualizacji:',
  'Alanlar yüklendi:': 'Pola załadowane:',
  'alan': 'pole',
  'Connect Free!': 'Połącz się za darmo!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Odkryj nasze najpopularniejsze produkty',
  'Tüm Kategoriler': 'Wszystkie kategorie',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 produktów wyświetlonych (Łącznie: 8000+)',
  'Tüm Ürünleri Gör →': 'Zobacz wszystkie produkty →',
  'Detaylar': 'Szczegóły',
  'Sipariş Ver': 'Zamów teraz',
  'Giriş Yap': 'Zaloguj się',
  'Hesabınıza giriş yapın': 'Zaloguj się do swojego konta',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Ta strona jest chroniona przez reCAPTCHA i obowiązuje Polityka prywatności Google oraz Warunki korzystania z usługi.',
  'Ürün Kataloğumuz': 'Nasz katalog produktów',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Oferujemy ponad 8000 produktów',
  '1,3B': '1,3K',
  'Partner': 'Partner',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Całkowita produkcja',
  '23': '23',
  'Branş': 'Oddział',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Całkowite zamówienia',
  'Connect Now': 'Połącz teraz',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Zarejestruj się za darmo, aby uzyskać dostęp do wszystkich informacji w jednym miejscu.',
  'Ürün Detayları': 'Szczegóły produktu',
  'Kapat': 'Zamknij',
  'Yükleniyor...': 'Ładowanie...',
  'Hata': 'Błąd',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} produktów wyświetlonych (Łącznie: 8000+)',
  'Şehir Seçimi': 'Wybór Miasta',
  'Firma / Sağlık Profesyoneli': 'Firma / Profesjonalista Zdrowia',
  'Yetkili Kişi': 'Osoba Upoważniona',
  'Telefon': 'Telefon',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Podstawowe Informacje',
  'Ek Bilgiler': 'Dodatkowe Informacje',
  'Faaliyet Alanı / Sektör': 'Obszar Działalności / Sektor',
  'Ülke Seçimi': 'Wybór Kraju',
  'Ülke adı veya kodu ara...': 'Szukaj nazwy lub kodu kraju...',
  'region.Avrupa': 'Europa',
  'region.Amerika': 'Ameryka',
  'region.Asya': 'Azja',
  'region.Afrika': 'Afryka',
  'region.Okyanusya': 'Oceania',
  'region.Diğer': 'Inne',
  'country.TR': 'Turcja',
  'country.US': 'Stany Zjednoczone',
  'country.DE': 'Niemcy',
  'country.FR': 'Francja',
  'country.GB': 'Wielka Brytania',
  'country.IT': 'Włochy',
  'country.ES': 'Hiszpania',
  'country.RU': 'Rosja',
  'country.CN': 'Chiny',
  'country.JP': 'Japonia',
  'country.KR': 'Korea Południowa',
  'country.IN': 'Indie',
  'country.BR': 'Brazylia',
  'country.CA': 'Kanada',
  'country.AU': 'Australia',
  'Ticaret Sicil No': 'Numer Rejestru Handlowego',
};
